import {
    CLEAR_NOTIFICATION,
    PUSH_NOTIFICATION,
    UPDATE_GAMMA_STATE,
    UPDATE_LAST_MAP_COUNT,
} from "../actionTypes/gamma.state.const";

const InitialState = {
    notifications: [],
    appsInstalled: {},
    keyboardShortcuts: {},
    keyboardShortcutsEnable: false,
    morpheusSettingInitialised: false,
    activeMapId: '0',
    activeAnnoDrawer: 0,
    selectedDrawTool: null,
    selectedDrawColor: "#7CFC00",
    sync: false,
    syncId: -1,
    syncQueue: 0,
    lastMapCount: 0,
    scale: 1,
}

export const gammaStateReducer = (state = InitialState, action) => {
    switch (action.type) {

        case UPDATE_GAMMA_STATE:
            return {
                ...state,
                ...action.state,
            }

        case PUSH_NOTIFICATION:
            return {
                ...state,
                notifications: [
                    action.notification,
                    ...state.notifications.filter(notification => notification.props.id !== action.notification.props.id),
                ],
            }

        case CLEAR_NOTIFICATION:
            return {
                ...state,
                notifications: [...state.notifications.filter(notification => notification.props.id !== action.id)],
            }

        case UPDATE_LAST_MAP_COUNT:
            return {
                ...state,
                lastMapCount: state.lastMapCount + 1,
            }

        default:
            return state;
    }
}
